import React from "react";
import { PieChart, Pie, Cell, Tooltip } from "recharts";
import { renderCustomizedLabel } from "./ChartCustomLabel";

const DeqPieChart = ({ data, colorArray, dataKey = "value", labelLine = false, width = 375, height = 325 }) => {
  return (
    <>
      <PieChart width={width} height={height}>
        <Pie data={data} cx='55%' cy='50%' labelLine={labelLine} label={renderCustomizedLabel} dataKey={dataKey}>
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={colorArray[index % colorArray.length]} />
          ))}
        </Pie>
            <Tooltip />
      </PieChart>
    </>
  );
};
export default DeqPieChart;
